import React, { useEffect, useRef, useState } from 'react';
import ApexCharts from 'apexcharts';
import TauriSectionModalVisual from '../TauriSectionBaseVisual/TauriSectionModalVisual/TauriSectionModalVisual';
import TauriSectionModalMultiVisual from '../TauriSectionBaseVisual/TauriSectionModalMultiVisual/TauriSectionModalMultiVisual';
import setting from '../../config.json';

const TauriTreeMapVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const chartRef = useRef(null);
    const [selectedVisual, setSelectedVisual] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (!chartData || !chartData?.[0]) return;

        const handleDataPointSelection = (event, chartContext, config) => {
            const selectedSliceIndex = config.dataPointIndex;
            const modalTitle = chartConfig.binding.context.point.onClick.selectedTitle;
            const title = chartConfig.binding.context.point.onClick.selectedValueColumn;
            const selectedDesc = chartData[selectedSliceIndex][chartConfig.binding.data.title];
            const selectedVal = chartData[selectedSliceIndex][title];
            const selectedTitle = chartConfig.title;

            if (chartConfig.binding.context.point.onClick.visual || Array.isArray(chartConfig.binding.context.point.onClick.visuals)) {
                let selectedVisual = null;
                if (chartConfig.binding.context.point.onClick.visuals) {
                    // Handle multiple visuals
                    const selectedSliceVisualIndex = config.dataPointIndex;
                    selectedVisual = chartConfig.binding.context.point.onClick.visuals;
                } else {
                    // Handle single visual
                    selectedVisual = chartConfig.binding.context.point.onClick.visual;
                }

                setSelectedVisual(selectedVisual);
                setSelectedData({ title, selectedDesc, selectedVal, selectedTitle, modalTitle });

                const tauriElement = document.querySelector('.tauri-host-container');
                if (tauriElement) {
                    if (event) {
                        const { left, top, right, bottom } = tauriElement.getBoundingClientRect();
                        let posX = event.clientX;
                        let posY = event.clientY;
                        if ((event.clientX + setting.modalMinWidth) > window.innerWidth) {
                            posX = event.clientX - setting.modalMinWidth;
                        }
                        if ((event.clientY + setting.modalMinHeight) > window.innerHeight) {
                            posY = event.clientY - setting.modalMinHeight;
                        }

                        setModalPosition({ x: posX, y: posY });
                    }
                }
            }
        };

        const filteredData = chartData.filter(item =>
            item[chartConfig.binding.data.title] !== undefined &&
            item[chartConfig.binding.data.value] !== undefined
        );

        const options = {
            chart: {
                ...chartOptions.chart,
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                    }
                },
                events: {
                    dataPointSelection: handleDataPointSelection,
                }
            },
            dataLabels: {
                ...chartOptions.dataLabels,
                formatter: function (val, opts) {
                    let formattedValue = opts.value.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                    if (chartConfig.binding.data.percent) {
                        formattedValue += '%';
                    }
                    return `${val}: ${formattedValue}`;
                }
            },
            tooltip: {
                y: {
                    formatter: (value, { seriesIndex, dataPointIndex, w }) => {
                        const tooltipValue = chartData[dataPointIndex][chartConfig?.binding?.data?.tooltip] || '';
                        const formattedValue = tooltipValue.toLocaleString(undefined, { maximumFractionDigits: setting.DISPLAYED_DECIMALS });
                        if (chartConfig.binding.data.percent) {
                            return formattedValue + ' (PHP)';
                        } else {
                            return formattedValue;
                        }
                    },
                    style: chartOptions.tooltip.style,
                }
            },
            plotOptions: chartOptions.plotOptions,
            yaxis: {

                min: 50 // Ensure that the y-axis starts at 0 to display data points with a value of 0
            },
            series: [{
                data: filteredData.map((item, index) => {
                    const effectiveIndex = index % chartPalettes.length;
                    return {
                        x: item[chartConfig.binding.data.title],
                        y: chartConfig.binding.data.percent ? item[chartConfig.binding.data.value] + '%' : item[chartConfig.binding.data.value],
                        fillColor: chartPalettes[effectiveIndex]?.ranges[0] || '#000'  // Use effective index for color
                    };
                })
            }]
        };


        const chart = new ApexCharts(chartRef.current, options);

        chart.render();

        return () => {
            chart.destroy();
        };
    }, [chartConfig, chartData]);


    return (
        <div>
            <div className='chart-content'>
                <div ref={chartRef} />
            </div>
            {selectedVisual && (
                chartConfig.binding.context.point.onClick.visuals ? (
                    <TauriSectionModalMultiVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                ) : (
                    <TauriSectionModalVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                )
            )}
        </div>
    );
};

export default TauriTreeMapVisual;